<script>
import { browser } from '$app/environment'
import { afterNavigate, onNavigate } from '$app/navigation'
import { Toaster } from '$lib/components/ui/sonner'
import { onMount } from 'svelte'

/**
 * @typedef {Object} Props
 * @property {import('svelte').Snippet} [children]
 */

/** @type {Props} */
let { children } = $props()

onNavigate((navigation) => {
  if (!document.startViewTransition) return

  return new Promise((resolve) => {
    document.startViewTransition(async () => {
      resolve()
      await navigation.complete
    })
  })
})

// Ping the visit beacon on the initial load and every client-side navigation.
// The site is prerendered, so static pages never hit server code — this client
// call is what lets the server log the visitor's IP + geo (see
// `src/routes/api/track-visit/+server.ts`).
afterNavigate(({ to, from }) => {
  if (!browser || !to) return

  const path = to.url.pathname
  // Skip duplicate fires when only the hash/search changes.
  if (from?.url.pathname === path && from.url.search === to.url.search) return

  void fetch(`/api/track-visit?path=${encodeURIComponent(path)}`, { keepalive: true })
})

function logScreenResolution() {
  if (!browser) return
  console.log(
    `[resize] viewport ${window.innerWidth}×${window.innerHeight} · screen ${screen.width}×${screen.height} · dpr ${window.devicePixelRatio}`,
  )
}

onMount(() => {
  if (!browser) return
  window.addEventListener('resize', logScreenResolution)
  return () => window.removeEventListener('resize', logScreenResolution)
})
</script>

{@render children?.()}
<Toaster />
